import React from "react";
import { useState } from "react";
import BodyHeader from "../common/BodyHeader";

import StarIcon from "assets/icons/Star.svg";
import BuildingIcon from "assets/icons/Building.svg";
import BriefcaseIcon from "assets/icons/BriefCase.svg";
import UsersIcon from "assets/icons/Users.svg";
import UserIcon from "assets/icons/Person.svg";
import MessageIcon from "assets/icons/Message.svg";
import ReusableCard from "../common/ReusableCard";
import OfferListCards from "../common/OfferListCards";
import Image1 from "assets/images/Image1.png";
import Image2 from "assets/images/Image2.png";
import Image3 from "assets/images/Image3.png";
import Image4 from "assets/images/Image4.png";
import Image5 from "assets/images/Image5.png";
import Image6 from "assets/images/Image6.png";
import PlusIcon from "assets/icons/Plus.svg";
import Image7 from "assets/images/Image7.png";
import Image8 from "assets/images/Image8.png";
import Image9 from "assets/images/Image9.png";
import Building from "assets/icons/Building.svg";
import BookMark from "assets/icons/BookMark.svg";
import Menu from "assets/icons/Menu.svg";
import { Modal } from "@mui/material";
import { toast } from "react-hot-toast";
import PropertiesCard from "../common/properties/PropertiesCard";
import { Property } from "../../../service";
const dummyProperties = [
  {
    id: 1,
    propertyTitle: "Pine Avenue Duplex",
    streetAddress: "123 Oak Street, Austin, TX",
    propertyType: "Apartment",
    lastJobPosted: "HVAC Repair – Dec 15, 2024",
    status: "2 Active jobs",
  },
  {
    id: 2,
    propertyTitle: "Pine Avenue Duplex",
    streetAddress: "123 Oak Street, Austin, TX",
    propertyType: "Apartment",
    lastJobPosted: "HVAC Repair – Dec 15, 2024",
    status: "2 Active jobs",
  },
  {
    id: 3,
    propertyTitle: "Pine Avenue Duplex",
    streetAddress: "123 Oak Street, Austin, TX",
    propertyType: "Apartment",
    lastJobPosted: "HVAC Repair – Dec 15, 2024",
    status: "2 Active jobs",
  },
];
const dummyCompletedJobs = [
  {
    id: 1,
    propertyTitle: "Pine Avenue Duplex",
    jobTitle: "HVAC System Repair",
    contractorName: "James & Sons HVAC",
    completionDate: "Completed on June 10, 2025",
  },
  {
    id: 2,
    propertyTitle: "Pine Avenue Duplex",
    jobTitle: "HVAC System Repair",
    contractorName: "James & Sons HVAC",
    completionDate: "Completed on June 10, 2025",
  },
  {
    id: 3,
    propertyTitle: "Pine Avenue Duplex",
    jobTitle: "HVAC System Repair",
    contractorName: "James & Sons HVAC",
    completionDate: "Completed on June 10, 2025",
  },
];
export default function LandlordHomepage() {
  const [property, setProperty] = React.useState(dummyProperties);
  const [completedJobs, setCompletedJobs] = React.useState(dummyCompletedJobs);
  const [editProperty, setEditProperty] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [deleteConfirm, setDeleteConfirm] = useState({
    show: false,
    propertyId: null,
    propertyName: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 7;
  const [open, setOpen] = useState("");
  const [jobs, setJobs] = React.useState([
    {
      id: 1,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 2,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 3,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 4,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 5,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 6,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
  ]);
  const [proposals, setProposals] = React.useState([
    {
      id: 1,
      name: "James Plumbing Co.",
      jobTitle: "Kitchen Faucet Repair",
      rating: 4,
      quote: "$150",
      response: "Replied in 2h",
      status: "New",
      image: Image1,
    },
    {
      id: 2,
      name: "James Plumbing Co.",
      jobTitle: "Kitchen Faucet Repair",
      rating: 4,
      quote: "$150",
      response: "Replied in 2h",
      status: "Pending",
      image: Image2,
    },
    {
      id: 3,
      name: "James Plumbing Co.",
      jobTitle: "Kitchen Faucet Repair",
      rating: 4.5,
      quote: "$150",
      response: "Replied in 2h",
      status: "Hired",
      image: Image3,
    },
  ]);
  const totalPages = Math.ceil(jobs.length / resultsPerPage);
  const tabs = [
    {
      icon: StarIcon,
      number: "3",
      label: "Active jobs",
    },
    {
      icon: BuildingIcon,
      number: "5",
      label: "Saved properties",
    },
    {
      icon: BriefcaseIcon,
      number: "12",
      label: "Offers received",
    },
    {
      icon: UsersIcon,
      number: "5",
      label: "Hired contractors",
    },
    {
      icon: UserIcon,
      number: "8",
      label: "Favorite contractors",
    },
    {
      icon: MessageIcon,
      number: "8",
      label: "New Messages",
    },
  ];
  const handleDelete = (id) => {
    const loadingToastId = toast.loading("Deleting property...");
    Property.deleteProperties(id)
      .then((res) => {
        console.log(res);
        toast.success("Property deleted successfully!");
        toast.dismiss(loadingToastId);
        setDeleteConfirm({ show: false, propertyId: null, propertyName: "" });
        // Call onRefresh callback to refresh properties list
        if (onRefresh) onRefresh();
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.message || "Failed to delete property"
        );
        toast.dismiss(loadingToastId);
      });
  };
  const handleDeleteClick = (id, propertyName) => {
    setDeleteConfirm({ show: true, propertyId: id, propertyName });
    setOpenDropdownId(null);
  };
  const fetchProperties = () => {
    if (userData) {
      setLoading(true);
      Property.getProperties(userData.id)
        .then((res) => {
          setProperty(res.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching properties:", error);
          setLoading(false);
        });
    }
  };
  return (
    <div className="px-6 pt-[92px] max-w-[1440px] mx-auto">
      <div className="md:py-12 py-6 space-y-12">
        <BodyHeader
          title="Welcome back!"
          description="Here's what's happening with your properties."
        >
          <button
            onClick={() => setOpen("add")}
            className="bg-[#3cab5c]  flex gap-2 items-center justify-center h-12  text-nowrap  w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px]    py-3 rounded-xl font-medium"
          >
            <img src={PlusIcon} className="w-[14px] h-[14px]"></img> Post a job
          </button>
        </BodyHeader>
        <div className="flex gap-4 flex-wrap">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className="flex px-4 py-3 flex-1 min-w-[185px] md:max-w-[250px] max-w-[300px] w-full  items-center gap-2 bg-[#F8F8F8] rounded-[16px]"
            >
              <img src={tab.icon} className="w-[20px] h-[20px]"></img>
              <div>
                {" "}
                <h1 className="md:text-[40px] leading-[40px] text-[24px] font-medium text-[#242424]">
                  {tab.number}
                </h1>
                <p className="md:text-[16px] text-[12px] font-medium text-[#242424]">
                  {tab.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="md:py-12 py-6">
        <div className="flex gap-4 flex-wrap md:flex-row flex-col">
          <div className="md:flex-[1.4] lg:flex-[1.92] flex-1  ">
            <div className="flex w-full gap-1 flex-col sm2:flex-row justify-between">
              <h1 className="md:text-[40px] md:mb-8 mb-4 text-[24px] text-[#242424] font-medium">
                Active Jobs
              </h1>
              <button className="bg-[#F8F8F8] w-fit nowrap text-nowrap text-[12px]  md:text-[16px]  flex gap-2 items-center justify-center border-[#ECECEC] text-[#242424]  md:h-12  h-10   hover:bg-[#3c8f47]  p-2  md:p-3 sm:text-[14px] lg:text-[16px]    rounded-xl font-medium">
                View all
              </button>
            </div>{" "}
            <ReusableCard
              resultsPerPage={7}
              jobs={jobs}
              classGrid="grid grid-cols-1 md:gap-6 gap-2 "
            ></ReusableCard>
          </div>
          <div className="flex-1">
            <div className="flex w-full gap-1 flex-col sm2:flex-row justify-between">
              <h1 className="md:text-[40px] md:mb-8 mb-4 text-[24px] text-[#242424] font-medium">
                Recent Offers
              </h1>
              <button className="bg-[#F8F8F8] w-fit nowrap text-nowrap text-[12px]  md:text-[16px]  flex gap-2 items-center justify-center border-[#ECECEC] text-[#242424]  md:h-12  h-10   hover:bg-[#3c8f47]  p-2  md:p-3 sm:text-[14px] lg:text-[16px]    rounded-xl font-medium">
                View all
              </button>
            </div>{" "}
            <OfferListCards
              showPagination={false}
              resultsPerPage={3}
              offers={proposals}
              classGrid="grid-cols-1 "
            ></OfferListCards>
          </div>
        </div>
      </div>
      <div className="md:py-12 py-6">
        <div className="flex w-full justify-between">
          <h1 className="md:text-[40px] text-[24px] mb-8 text-[#242424] font-medium">
            Saved properties
          </h1>
          <button
            onClick={() => setOpen("add")}
            className="bg-[#3cab5c]  flex gap-2 items-center justify-center h-12  text-nowrap  w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px]    py-3 rounded-xl font-medium"
          >
            <img src={PlusIcon} className="w-[14px] h-[14px]"></img> Add
            Property
          </button>
        </div>{" "}
        <PropertiesCard
          btnText="Post job at this address"
          showPagination={false}
          offers={property}
          setOpen={setOpen}
          setEditProperty={setEditProperty}
          onRefresh={fetchProperties}
        >
          {(offer, cardId) => (
            <div className="flex justify-between ">
              <div className="bg-[#ECEEF2] p-3 rounded-[8px]">
                <img
                  src={Building}
                  alt="avatar"
                  className="w-5 h-5  rounded-full "
                />
              </div>
              <div className="relative flex gap-4">
                <img className="w-6 h-6" src={BookMark} alt="Bookmark" />
                <img
                  onClick={() =>
                    setOpenDropdownId(openDropdownId === cardId ? null : cardId)
                  }
                  className="w-6 h-6 cursor-pointer"
                  src={Menu}
                  alt="Menu"
                />
                {openDropdownId === cardId && (
                  <div className="absolute right-0 top-8 z-10 bg-white border border-gray-200 rounded shadow-md w-32">
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                      onClick={() => {
                        setOpen("viewDetails");
                        setOpenDropdownId(null);
                      }}
                    >
                      View Details
                    </button>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                      onClick={() => {
                        handleOpen("edit", offer);
                        setOpenDropdownId(null);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
                      onClick={() =>
                        handleDeleteClick(offer.id, offer.propertyTitle)
                      }
                    >
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </PropertiesCard>
      </div>
      <div className="md:py-12 py-6">
        <div className="flex w-full justify-between">
          <h1 className="md:text-[40px] text-[24px] text-[#242424] mb-8 font-medium">
            Recently Completed Jobs
          </h1>
          <button className="bg-[#F8F8F8] w-fit nowrap text-nowrap text-[12px]  md:text-[16px]  flex gap-2 items-center justify-center border-[#ECECEC] text-[#242424]  md:h-12  h-10   hover:bg-[#3c8f47]  p-2  md:p-3 sm:text-[14px] lg:text-[16px]    rounded-xl font-medium">
            View all
          </button>
        </div>{" "}
        <PropertiesCard
          showPagination={false}
          offers={completedJobs}
          setOpen={setOpen}
          setEditProperty={setEditProperty}
          onRefresh={fetchProperties}
        ></PropertiesCard>
      </div>
    </div>
  );
}
